import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{contactData.title}</h2>
        <p className="text-sm text-foreground-500 mb-8">{contactData.subtitle}</p>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{contactData.description}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <button className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-send-plane-line mr-2"></i>提交爆料
          </button>
          <button className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer border border-background-300">
            <i className="ri-mail-line mr-2"></i>邮件投稿
          </button>
        </div>
        <p className="text-xs text-foreground-400">{contactData.note}</p>
      </div>
    </section>
  );
}